/**
 * Who can enrol in a cohort and how a place is paid (07.10.2026) — the
 * form's side of `services/groups/private_link.py`. The server has the last
 * word; this only says the same things before saving.
 */
export const ACCESS_OPTIONS = [
  { value: "public", label: "Oricine, de pe site", hint: "Grupa apare pe site imediat ce o salvezi. Ca s-o ascunzi, folosește „Ascunde de pe site” din meniul ei." },
  { value: "link", label: "Doar cu link", hint: "Nu apare pe site. Se înscrie doar cine primește linkul grupei." },
];

export const BILLING_OPTIONS = [
  { value: "individual", label: "Fiecare cursant, la înscriere", hint: "Ca pe site: fiecare își plătește locul." },
  { value: "institution", label: "Factură către instituție",
    hint: "Nimeni nu plătește la înscriere. Echipa confirmă fiecare participant și facturează instituția manual." },
];

/** What is wrong with the access settings, or null. */
export function accessProblem(form) {
  const f = form || {};
  if (f.billing_mode === "institution" && f.access !== "link") {
    return "Factura către instituție merge doar la o grupă privată, cu link: pe site, oricine s-ar putea înscrie fără să plătească.";
  }
  if (f.billing_mode === "institution" && !String(f.institution_name || "").trim()) {
    return "Scrie numele instituției care primește factura.";
  }
  return null;
}

/** The link a school is sent, on whatever address the admin is open. */
export function enrolmentUrl(code, origin = typeof window !== "undefined" ? window.location.origin : "https://ai.fped.org") {
  return code ? `${origin}/inscriere/${code}` : "";
}

/** The chips on a cohort's row in the list. */
export function accessChips(group) {
  const g = group || {};
  if (g.access !== "link") return [];
  const chips = [{ key: "link", label: g.institution_name ? `doar cu link · ${g.institution_name}` : "doar cu link" }];
  if (g.billing_mode === "institution") chips.push({ key: "invoice", label: "factură instituție" });
  if (g.enrolment_link && g.enrolment_link.active === false) chips.push({ key: "paused", label: "link oprit" });
  return chips;
}

/** The cohort's own price per person (09.10.2026), as the form holds it:
 *  "" for "the site's price", else what was typed. */
export function priceProblem(value) {
  const raw = String(value ?? "").trim().replace(",", ".");
  if (!raw) return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return "Prețul special trebuie să fie un număr, în lei.";
  return null;
}

/** What goes to the server: the amount, or 0 to go back to the site's price. */
export function pricePayload(value) {
  const raw = String(value ?? "").trim().replace(",", ".");
  const n = Number(raw);
  return raw && Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0;
}

const lei = (n) => `${Number(n).toLocaleString("ro-RO", { maximumFractionDigits: 2 })} lei`;

/** "preț special · 900 lei", or null when the cohort charges the site's price. */
export function priceChip(group) {
  const n = Number(group?.price);
  return Number.isFinite(n) && n > 0 ? `preț special · ${lei(n)}` : null;
}

/** Whether the cohort's participants may pay with the Prima de Carieră Didactică
 *  card (12.10.2026). Missing means yes: every cohort made before the switch. */
export function primaAccepted(group) {
  return group?.prima_card !== false;
}

/** "fără card Prima", or null when the cohort takes the card, as most do. */
export function primaChip(group) {
  return primaAccepted(group) ? null : "fără card Prima";
}

/** The line under the price field: what the cohort charges, against the site's. */
export function priceNote(value, sitePrice, enrolled = 0) {
  const n = pricePayload(value);
  const site = Number(sitePrice);
  const base = n > 0
    ? `Toți cei care se înscriu în această grupă plătesc ${lei(n)}${Number.isFinite(site) && site > 0 ? ` (pe site: ${lei(site)})` : ""}.`
    : `Gol = prețul de pe site${Number.isFinite(site) && site > 0 ? ` (${lei(site)})` : ""}.`;
  const kept = enrolled === 1 ? " Cine s-a înscris deja își păstrează prețul de la înscriere."
    : enrolled > 1 ? ` Cei ${enrolled} înscriși până acum își păstrează prețul de la înscriere.` : "";
  return base + kept;
}
